<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th>{{ $t('Code') }}</th>
      </tr>
    </thead>

    <Sortable
      :list="items"
      item-key="id"
      tag="tbody"
      :options="{handle:'.draggable-handle'}"
      @end="updateOrder"
    >
      <template #item="{element: activityOption, index}">
        <tr :key="activityOption.id">
          <td style="width: 20px">
             <span class="draggable-handle">
                <i class="fa fa-sort" aria-hidden="true"></i>
              </span>
          </td>
          <td>{{ activityOption.code }}</td>
        </tr>
      </template>
    </Sortable>
  </table>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Sortable } from "sortablejs-vue3";
import axios from 'axios';

const props = defineProps({
  activityOptions: {
    type: Array,
    required: true
  },
  orderUrl: {
    type: String,
    required: true
  },
});

const items = ref([...props.activityOptions]);

watch(() => props.activityOptions, (newVal) => {
  items.value = [...newVal];
});

function updateOrder(event) {
  items.value.splice(event.newIndex, 0, items.value.splice(event.oldIndex, 1)[0]);
  axios.put(props.orderUrl, {
    order: items.value.map((item) => item.id)
  })
  .catch(function (error) {
    alert(error);
  });
}
</script>

<style scoped>

</style>
